module.exports = __webpack_public_path__ + "static/media/scroll.6039870c.svg";